import DynamicTable from '@atlaskit/dynamic-table';
import { MarketplaceBillingCycleValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { useFeatureFlags } from '@atlassian/mpac-ui';
import React from 'react';
import { PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS } from "../../../../../constants";
import { getTierCeiling } from "../PricingCalculatorSection/CloudPricingCalculator/CloudPricingCalculator.utils";
import { formatAmount } from "../PricingTab.utils";
import { createPricingExamples } from "../PricingTiers/PerUserPricing/PerUserPricingTiers.utils";
import { PricingTierTableAmountCell as AmountCell, PricingTierTableCell as UnitCell } from "../PricingTiers/PricingTiers.styles";

const getHeader = (billingCycle, displayPricingCalculator) => {
  const result = [{
    isSortable: false,
    key: 'ceiling',
    content: 'Team Size'
  }, {
    isSortable: false,
    key: 'price',
    content: displayPricingCalculator ? /*#__PURE__*/React.createElement(AmountCell, null, billingCycle === MarketplaceBillingCycleValues.Annual ? 'Annual price' : 'Monthly per user') : /*#__PURE__*/React.createElement(AmountCell, null, "".concat(billingCycle === MarketplaceBillingCycleValues.Annual ? 'Annual' : 'Monthly', " price"))
  }];

  if (displayPricingCalculator) {
    return result;
  }

  result.push({
    isSortable: false,
    key: 'averagePrice',
    content: /*#__PURE__*/React.createElement(AmountCell, null, "Average price/user")
  });
  return result;
};

const createPricingTiers = (tiers, currency) => {
  return tiers.map(tier => {
    const ceiling = getTierCeiling(tier);
    return {
      teamSize: tier.floor === 1 ? "Up to ".concat(ceiling) : "".concat(tier.floor, "-").concat(ceiling),
      price: tier.amount === 0 ? 'Free' : formatAmount(tier.amount, {
        currency,
        minimumFractionDigits: PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS
      })
    };
  });
};

const getRows = (items, currency, displayPricingCalculator) => {
  if (displayPricingCalculator) {
    const examples = createPricingTiers(items, currency);
    return examples.map(example => {
      const cells = [{
        content: /*#__PURE__*/React.createElement(UnitCell, null, example.teamSize)
      }, {
        content: /*#__PURE__*/React.createElement(AmountCell, null, example.price)
      }];
      return {
        cells
      };
    });
  }

  const examples = createPricingExamples(items, currency);
  return examples.map(example => {
    const cells = [{
      content: /*#__PURE__*/React.createElement(UnitCell, null, example.teamSize)
    }, {
      content: /*#__PURE__*/React.createElement(AmountCell, null, example.price)
    }, {
      content: /*#__PURE__*/React.createElement(AmountCell, null, example.averagePrice)
    }];
    return {
      cells
    };
  });
};

export const PerUserPricingTiersTable = props => {
  const {
    items,
    currency,
    billingCycle
  } = props;
  const {
    displayPricingCalculator
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement(DynamicTable, {
    head: {
      cells: getHeader(billingCycle, displayPricingCalculator)
    },
    rows: getRows(items, currency, displayPricingCalculator)
  });
};